
/**
* First we will load all of this project's JavaScript dependencies which
* includes Vue and other libraries. It is a great starting point when
* building robust, powerful web applications using Vue and Laravel.
*/

import './bootstrap';
// import 'babel-polyfill';
// import '@babel/polyfill'
// window.Vue = require('vue');
import Vue from 'vue';
// var VueScrollTo = require('vue-scrollto');

// import * as VueGoogleMaps from 'vue2-google-maps';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';
// import {VueTabs, VTab} from 'vue-nav-tabs';
import FixedHeader from 'vue-fixed-header';
// Próbáld így:
Vue.component('fixed-header', FixedHeader.default || FixedHeader);
import CookieLaw from 'vue-cookie-law'
// import 'vue-nav-tabs/themes/vue-tabs.css';

// import vSelect from "vue-select";

// import Vuex from 'vuex';
/**
* The following block of code may be used to automatically register your
* Vue components. It will recursively scan this directory for the Vue
* components and automatically register them with their "basename".
*
* Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
*/

// Vue.component('navMenu', require('./components/NavMenu.vue'));
// import SzallitasiIdo from './components/simpleshop/szallitasiido.vue';
// import VueSelect from './components/simpleshop/vueselect.vue';
// import ProductListNav from './components/simpleshop/productlistnav.vue';
// import AszfCheckbox from './components/simpleshop/aszfcheckbox.vue';

// import KuponKod from './components/simpleshop/kuponkod.vue';
// import RendelesMegjegyzes from './components/simpleshop/rendelesmegjegyzes.vue';
// import PostaPont from './components/simpleshop/postapont.vue';
//
// import radiobox from './components/simpleshop/radiobox.vue';
// import radioboxArr from './components/simpleshop/radioboxarr.vue';
// import Kosarbol from './components/simpleshop/kosarbol.vue';
// import Kosar from './components/simpleshop/kosar.vue';
// import KosarTorles from './components/simpleshop/kosartorles.vue';
// import KedvencTermek from './components/simpleshop/kedvenctermek.vue';
// import ProductDb from './components/simpleshop/productdb.vue';
import RoastopusProductPrice from './components/simpleshop/roastopus-product-price.vue';
import RoastopusCartElementSmall from './components/simpleshop/roastopus-cart-element-small.vue';
import CartList from './components/simpleshop/roastopus-cart.vue';
import Checkout from './components/simpleshop/roastopus-checkout.vue';
// import FoxpostSelect from './components/simpleshop/foxpost-select.vue';
import ParcelpointSelect from './components/simpleshop/parcelpoint-select.vue';
import Landing1ContactBox from './components/landing1-contact-box.vue';

// import AszfCheckbox from './components/simpleshop/aszfcheckbox.vue';
 import StripeCheckout from './components/simpleshop/stripe-checkout.vue';

// import KuponKod from './components/kuponkod.vue';
import CheckoutComment from './components/simpleshop/checkout-comment.vue';
// import PostaPont from './components/postapont.vue';

// import radiobox from './components/simpleshop/radiobox.vue';
// import radioboxArr from './components/simpleshop/radioboxarr.vue';


// import TermekListaDb from './components/simpleshop/termeklistadb.vue';
// import TermekListaDbSmall from './components/simpleshop/termeklistadbsmall.vue';
// import KosarListaElem from './components/simpleshop/kosarlistaelem.vue';
// import ProductlistNav from './components/simpleshop/productlistnav.vue';

// import ProductFilter from './components/productfilter.vue';
import VueCurrencyFilter from 'vue-currency-filter';


Vue.filter('shortdate', function (value ) {
    // here `input` === `this.userInput`
    return value.substr(0, 16);
});

Vue.filter('payment_method_text', function (value ) {
    let ret = "";
    switch(value) {
        case "FIZP": ret = "Készpénzzel";
        break;
        //        case "FIZK": ret = "Készpénzzel";
        break;
        case "FIZU": ret = "Banki utalással";
        break;
        case "FIZFH": ret = "Fizetés a házhozszállításnál bankkártyával";
        break;
        case "FIZFB": ret = "Fizetés a csomagautomatánál bankkártyával";
        break;

    }
    return ret;
});
Vue.filter('shipping_method_text', function (value ) {
      console.log('shipping_method_text filter [x]', value);
    let ret = "";
    if (value) {
        // console.log('??', value.name);
        ret = value.name;
        // switch(value.id) {
        //     case "P": ret = "Postai kiszállítással";
        //     break;
        //     case "P2": ret = "Postai kiszállítással";
        //     break;
        //     case "F": ret = "Kiszállítás futárral";
        //     break;
        //     case "FOXH": ret = "Házhoz szállítás Foxpost futárszolgálat közreműködésével";
        //     break;
        //     case "FOXP": ret = "Kiszállítás Foxpost csomagautomatába";
        //     break;
        // }
    }
    return ret;
});

// import { StripePlugin } from '@vue-stripe/vue-stripe';

// const options = {
//   pk: process.env.MIX_STRIPE_KEY,
//   stripeAccount: process.env.STRIPE_ACCOUNT,
//   apiVersion: process.env.API_VERSION,
//   locale: process.env.LOCALE,
// };

// Vue.use(StripePlugin, options);



// import { StripeCheckout } from '@vue-stripe/vue-stripe';

// import { StripeElementCard } from '@vue-stripe/vue-stripe';
// import { StripePlugin } from '@vue-stripe/vue-stripe';

// const options = {
//   pk: process.env.MIX_STRIPE_KEY,
//   stripeAccount: process.env.STRIPE_ACCOUNT,
//   apiVersion: process.env.API_VERSION,
//   locale: process.env.LOCALE,
// };

// Vue.use(StripePlugin, options);





// Vue.component('szallitasiIdo', SzallitasiIdo); // nem kell
// Vue.component('vueSelect', VueSelect);
// Vue.component('productlistNav', ProductlistNav);
// Vue.component('aszfCheckbox', AszfCheckbox);

// Vue.component('kuponKod', KuponKod);
Vue.component('CheckoutComment', CheckoutComment);
// Vue.component('postaPont', PostaPont);
// Vue.component('radiobox', radiobox);
// Vue.component('radioboxArr', radioboxArr);
// Vue.component('kosarbol', Kosarbol);
// Vue.component('kosar', Kosar);
// Vue.component('kosar-torles', KosarTorles);
// Vue.component('kedvencTermek', KedvencTermek);
// Vue.component('productDb', ProductDb);
Vue.component('RoastopusProductPrice', RoastopusProductPrice);
Vue.component('RoastopusCartElementSmall', RoastopusCartElementSmall);
Vue.component('CartList', CartList);
Vue.component('Checkout', Checkout);


// Vue.component('termekListaDb', TermekListaDb);
// Vue.component('termekListaDbSmall', TermekListaDbSmall);
// Vue.component('KosarlistaElem', KosarListaElem);
// Vue.component('ProductlistNav', ProductlistNav);




import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import CartMenu from './components/simpleshop/cart-menu.vue';
import CartNav from './components/simpleshop/cart-nav.vue';

// import VuePhoneNumberInput from 'vue-phone-number-input';
// import 'vue-phone-number-input/dist/vue-phone-number-input.css';
// Vue.component('vue-phone-number-input', VuePhoneNumberInput);

// import { MazPhoneNumberInput } from 'maz-ui'
// import 'maz-ui/lib/css/maz-phone-number-input.css'
// import '/resources/sass/vendor/maz/_variables/_root-variables.scss'
// Vue.use(MazPhoneNumberInput)


import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';

Vue.use(VueTelInput);
import Phone from './components/phone.vue';
Vue.component('Phone',Phone);



import VeeValidate, { Validator } from 'vee-validate';
import messagesHu from 'vee-validate/dist/locale/hu.js';
Validator.localize('hu', messagesHu);

const validateConfigHu = {
    locale: 'hu',
    inject: false,
    dictionary: {

        hu: {
            messages: messagesHu,
            attributes: {
                name: 'név',
                email: 'e-mail',
                phone: 'telefon',
                password: 'jelszó',
                password_confirmation:  'jelszó',

                billing_name: 'számlázás: név',
                billing_city: 'számlázás: település',
                billing_postcode: 'számlázás: irányányítószám',
                billing_address: 'számlázás: cím',
                tax_number: 'Adószám',

                shipping_name: 'postázás: név',
                shipping_city: 'postázás: település',
                shipping_postcode: 'postázás: irányányítószám',
                shipping_address: 'postázás: cím'


            }
        }
    }
}

// Vue.use(VeeValidate, validateConfig);
const validateConfigEn = {
    locale: 'en',
    inject: false
}
switch (window.default_locale) {
    case 'hu':
    // console.log('window.default_locale=' + window.default_locale);
    Validator.localize('hu', messagesHu);
    Vue.use(VeeValidate, validateConfigHu);

    break;
    case 'en':
    // console.log('window.default_localeEN=' + window.default_locale);

    Validator.localize('en');
    Vue.use(VeeValidate, validateConfigEn);


    break;
}



if (window.default_locale == 'hu') {
    // const floatingPrecision = 0;
    Vue.use(VueCurrencyFilter, {
        symbol: ' Ft',
        thousandsSeparator: ' ',
        fractionCount: 0,
        fractionSeparator: ',',
        symbolPosition: 'end',
        symbolSpacing: true
    });
}

if (window.default_locale == 'en') {
    // const floatingPrecision = 2;

    Vue.use(VueCurrencyFilter, {
        symbol: ' EUR',
        thousandsSeparator: ' ',
        fractionCount: 2,
        fractionSeparator: ',',
        symbolPosition: 'end',
        symbolSpacing: true
    });
}

// import VueLang from '@eli5/vue-lang-js'

// Vue.use(VueLang, {
//     messages: window.messages, // Provide locale file
//     locale: window.default_locale, // Set locale
//     fallback: window.fallback_locale // Set fallback lacale
// })
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
// Az i18n példányt létrehozod
const i18n = new VueI18n({
  locale: window.default_locale, // pl: 'en'
  fallbackLocale: window.fallback_locale, // pl: 'en'
  messages: window.messages
});

// import EasySlider from 'vue-easy-slider'
// import { Slider, SliderItem } from 'vue-easy-slider'
// Vue.use(EasySlider)


// import style (>= Swiper 6.x)
// import 'swiper/swiper-bundle.css'
// import VueSplide from '@splidejs/vue-splide';
// import '@splidejs/splide/dist/css/themes/splide-default.min.css';
// Vue.use( VueSplide );

// import VueSplide from '@splidejs/vue-splide';

// Vue.use( VueSplide );


import VueAwesomeSwiper from 'vue-awesome-swiper'
// import style (<= Swiper 5.x)
import 'swiper/css/swiper.css'
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)

// Vue.use(Vuex);
Vue.use(VeeValidate);
Vue.use(Loading,{
    width: 34,
    height: 34,
    backgroundColor: '#ffffff',
    opacity: 0.8,
    zIndex: 999,
});

import velocity from 'velocity-animate';
import Notifications from 'vue-notification';
const Plugin = Notifications?.default ?? Notifications;
Vue.use(Plugin, { velocity });

import FullpageModal from './plugins/vue-fullpage-modal/index.js'
Vue.use(FullpageModal)
// Debug:
// console.log('$FModal a prototype-on:', Vue.prototype.$FModal)

import VueScrollTo from 'vue-scrollto';
Vue.use(VueScrollTo, {
    container: "body",
    duration: 500,
    easing: "ease",
    offset: -85,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
})

Vue.component('cookie-law',CookieLaw);
// Vue.component('vue-tabs', VueTabs);
// Vue.component('v-tab', VTab);
// Vue.component('v-select', vSelect);

// Vue.component('foxpost-select', FoxpostSelect);
Vue.component('parcelpoint-select', ParcelpointSelect);

import { TabsPlugin } from 'bootstrap-vue'
Vue.use(TabsPlugin)

Vue.component('cart-menu', CartMenu);
Vue.component('cart-nav', CartNav);
// import './mapstyle.js';
import './productlist';
import './teamlist';
import './components/registration-form';
import './components/profile-form';

// Vue.component('google-map', VueGoogleMaps.Map);
// Vue.component('google-marker', VueGoogleMaps.Marker);
// Vue.use(VueGoogleMaps, {
//     load: {
//         key: 'AIzaSyAYo_rRaGZDpehGcaah3XRrMLXLsdMfM0s',
//         // key: 'AIzaSyAoDBbA4aBSLgVfTDL3QiImIMPw6rvJ4ys', // dev key
//         // libraries: 'marker', // This is required if you use the Autocomplete plugin

//     }
// });



// Vue.use(ValidationProvider);

import GoogleReCaptchaV3 from './components/googlerecaptchav3/GoogleReCaptchaV3.vue';
Vue.component('google-re-captcha-v3', GoogleReCaptchaV3);
//
// Vue.component(
//     'passport-clients',
//     require('./components/passport/Clients.vue').default
// );
//
// Vue.component(
//     'passport-authorized-clients',
//     require('./components/passport/AuthorizedClients.vue').default
// );
//
// Vue.component(
//     'passport-personal-access-tokens',
//     require('./components/passport/PersonalAccessTokens.vue').default
// );
//

// import Lang from 'lang.js';
//
// const default_locale = window.default_language;
// const fallback_locale = window.fallback_locale;
// const messages = window.messages;
//
// Vue.prototype.trans = new Lang( { messages, locale: default_locale, fallback: fallback_locale } );
//



//
// Raven
// .config('https://ca6e4b35ff32470b925f23a51bbdc5b7@sentry.io/1354986')
// .addPlugin(RavenVue, Vue)
// .install();
//



// var mapStyle =  [
//     {
//         "featureType": "water",
//         "elementType": "geometry.fill",
//         "stylers": [
//             {
//                 "color": "#d3d3d3"
//             }
//         ]
//     },
//     {
//         "featureType": "transit",
//         "stylers": [
//             {
//                 "color": "#808080"
//             },
//             {
//                 "visibility": "off"
//             }
//         ]
//     },
//     {
//         "featureType": "road.highway",
//         "elementType": "geometry.stroke",
//         "stylers": [
//             {
//                 "visibility": "on"
//             },
//             {
//                 "color": "#b3b3b3"
//             }
//         ]
//     },
//     {
//         "featureType": "road.highway",
//         "elementType": "geometry.fill",
//         "stylers": [
//             {
//                 "color": "#ffffff"
//             }
//         ]
//     },
//     {
//         "featureType": "road.local",
//         "elementType": "geometry.fill",
//         "stylers": [
//             {
//                 "visibility": "on"
//             },
//             {
//                 "color": "#ffffff"
//             },
//             {
//                 "weight": 1.8
//             }
//         ]
//     },
//     {
//         "featureType": "road.local",
//         "elementType": "geometry.stroke",
//         "stylers": [
//             {
//                 "color": "#d7d7d7"
//             }
//         ]
//     },
//     {
//         "featureType": "poi",
//         "elementType": "geometry.fill",
//         "stylers": [
//             {
//                 "visibility": "on"
//             },
//             {
//                 "color": "#ebebeb"
//             }
//         ]
//     },
//     {
//         "featureType": "administrative",
//         "elementType": "geometry",
//         "stylers": [
//             {
//                 "color": "#a7a7a7"
//             }
//         ]
//     },
//     {
//         "featureType": "road.arterial",
//         "elementType": "geometry.fill",
//         "stylers": [
//             {
//                 "color": "#ffffff"
//             }
//         ]
//     },
//     {
//         "featureType": "road.arterial",
//         "elementType": "geometry.fill",
//         "stylers": [
//             {
//                 "color": "#ffffff"
//             }
//         ]
//     },
//     {
//         "featureType": "landscape",
//         "elementType": "geometry.fill",
//         "stylers": [
//             {
//                 "visibility": "on"
//             },
//             {
//                 "color": "#efefef"
//             }
//         ]
//     },
//     {
//         "featureType": "road",
//         "elementType": "labels.text.fill",
//         "stylers": [
//             {
//                 "color": "#696969"
//             }
//         ]
//     },
//     {
//         "featureType": "administrative",
//         "elementType": "labels.text.fill",
//         "stylers": [
//             {
//                 "visibility": "on"
//             },
//             {
//                 "color": "#737373"
//             }
//         ]
//     },
//     {
//         "featureType": "poi",
//         "elementType": "labels.icon",
//         "stylers": [
//             {
//                 "visibility": "off"
//             }
//         ]
//     },
//     {
//         "featureType": "poi",
//         "elementType": "labels",
//         "stylers": [
//             {
//                 "visibility": "off"
//             }
//         ]
//     },
//     {
//         "featureType": "road.arterial",
//         "elementType": "geometry.stroke",
//         "stylers": [
//             {
//                 "color": "#d6d6d6"
//             }
//         ]
//     },
//     {
//         "featureType": "road",
//         "elementType": "labels.icon",
//         "stylers": [
//             {
//                 "visibility": "off"
//             }
//         ]
//     },
//     {},
//     {
//         "featureType": "poi",
//         "elementType": "geometry.fill",
//         "stylers": [
//             {
//                 "color": "#dadada"
//             }
//         ]
//     }
// ];

// Vue.mixin({
//     methods: {

//         __(text) {
//             // console.log('__(text)');
//             // console.log(text);
//             // console.warn(this.trans.get(text));
//             if (this.$trans(text) == text) {
//                 // console.log('[1]');
//                 return (text.replace("__JSON__.", ""))
//             } else {
//                 // console.log('[2]');
//                 return (this.$trans(text));
//             }
//         }
//     }
// });

// import { ValidationProvider } from 'vee-validate';

// import Phone from './components/phone.vue';
// Vue.component('Phone',Phone);


// MUKODO:
// Validator.extend('phone_rule', {
//   getMessage: field => `A ${field} rosszul van megadva!`,
//   validate: function (phoneObject) {
//     console.log('phone_rule validate function', phoneObject);
//     // phoneObject a wrapperből jön
//     if (!phoneObject) return false;
//     return phoneObject.valid === true;
//   }
// });
// Validator.extend('phone_rule', {

//     getMessage: field => 'A ' + field + ' rosszul adtad meg!',
//     validate: function (value) {
//         console.log('phone_rule');
//         console.log(value);
//         return value.isValid
//     }
//     // value => value ? value.isValid : null
//   });


// EZ JO mobilra es VEZETEKESRE IS
// Validator.extend('phone_rule', {
//   getMessage: field => `A ${field} rosszul van megadva!`,
//   validate: phoneObject => {
//     if (!phoneObject || !phoneObject.nationalNumber) return false;

//     // Ha libphonenumber szerint is hibás, elutasítjuk
//     if (phoneObject.isValid === false) return false;

//     if (phoneObject.countryCode === 'HU') {
//       const national = phoneObject.nationalNumber.replace(/\D/g, '');
//       const mobilePrefixes = ['20', '30', '31', '50', '70', '71'];

//       // Mobil
//       if (mobilePrefixes.includes(national.slice(0, 2))) {
//         return national.length === 9; // 2 prefix + 7 számjegy
//       }

//       // Vezetékes (Budapest: 1 + 7 számjegy, többi: 2 prefix + 6 számjegy)
//       if (national.startsWith('1')) {
//         return national.length === 8; // 1 + 7
//       }

//       return national.length === 8; // 2 prefix + 6
//     }

//     // Egyéb országokra a libphonenumber alapján
//     return phoneObject.isValid === true;
//   }
// });


// v2:
// Validator.extend('phone_rule', {
//   getMessage: field => `A ${field} nem érvényes!`,
//   validate: phoneObject => {
//     console.log('phone_rule típus:', typeof phoneObject, JSON.stringify(phoneObject));


//     console.log('phone_rule check?', phoneObject);
//     if (!phoneObject || !phoneObject.nationalNumber) {
//         console.log('return [1]', phoneObject);
//       return true;
//     }

//     // Ha még nincs country, várjuk a végleges értéket
//     if (!phoneObject.country) {
//          console.log('return [2]');
//       return true;
//     }

//     const national = phoneObject.nationalNumber.replace(/\D/g, '');
//     const country = phoneObject.country?.iso2;
//     const mobilePrefixesHU = ['20', '30', '31', '50', '70', '71'];

//     if (country === 'HU') {
//       const prefix = national.slice(0, 2);
//       return mobilePrefixesHU.includes(prefix) && national.length === 9;
//     }
//     console.log('minden oke, visszater ha valid');

//     return phoneObject.valid === true;
//   }
// });

Validator.extend('phone_rule', {
  getMessage: field => `A ${field} nem érvényes!`,
  validate: phoneObject => {
    // Üres / hiányos szám = ÉRVÉNYTELEN (korábban itt bypass volt: return true)
    if (!phoneObject || !phoneObject.nationalNumber || !phoneObject.country) {
      return false;
    }

    const national = phoneObject.nationalNumber.replace(/\D/g, '');
    const country = phoneObject.country?.iso2;
    const mobilePrefixesHU = ['20', '30', '31', '50', '70', '71'];

    if (country === 'HU') {
      const prefix = national.slice(0, 2);
      return mobilePrefixesHU.includes(prefix) && national.length === 9;
    }

    return phoneObject.valid === true;
  }
});

import mixin from './mixin.js'
const app = new Vue({
    i18n,
    el: '#app',
    components: {
        Landing1ContactBox,
        StripeCheckout,

        // StripeElementCard,
    },
    mixins: [mixin],
    data: function() {
        console.log(import.meta.env);
        return {
            publishableKey: import.meta.env.MIX_STRIPE_KEY,
            loading: false,

            stripeSuccessURL: '/your-success-url',
            stripeCancelURL: '/your-cancel-url',
            menu_visible: false,
            isFixedHeader: false,
            cartmenu_visible: false,
            cartmenu_loading: false,
            // mapStyle: {styles: mapStyle },
            list: [
                { backgroundColor: '#fff', width: '100%', height: '100%' },
                { backgroundColor: '#fff', width: '100%', height: '100%' },

            ],
            cart: [],
            cartArr: [],

            swiperOption: {
                slidesPerView: 1,
                spaceBetween: 0,
                slidesPerGroup: 1,
                loop: true,
                // loopFillGroupWithBlank: true,
                // watchSlidesVisibility: true,
                // centeredSlides: true,
                autoplay: {
                    delay: 7500,
                    disableOnInteraction: false
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                breakpoints: {
                    // when window width is <= 320px
                    320: {
                        createElements: false,
                        slidesPerView: 1,
                        spaceBetween: 10
                    },
                    // when window width is <= 480px
                    480: {
                        createElements: false,
                        slidesPerView: 1,
                        spaceBetween: 20
                    },
                    // when window width is <= 640px
                    640: {
                        slidesPerView: 1,
                        spaceBetween: 30
                    },
                    768: {
                        slidesPerView: 1,
                        spaceBetween: 0
                    }
                }
            },

            MoreProductSplideSliderOptions: {
                // rewind : true,
                loop: false,
                slidesPerView: 5,
                // width  : 1140,
                spaceBetween: 20,
                breakpoints: {
                    320: {
                        // centeredSlides: true,
                        slidesPerView: 1,
                        padding: {

                            left : 0,
                            right: '4rem'
                        }
                    },
                    480: {
                        // destroy: 'completely',
                        //  centeredSlides: false,

                        // width:'80%',
                        slidesPerView: 1,
                        // padding: {

                        //     left : 0,
                        //     right: '4rem'
                        // }
                    },
                    640: {

                        slidesPerView: 1,
                        padding: {

                            left : 0,
                            right: '4rem'
                        }
                    },
                    768: {

                        slidesPerView: 3,
                        // padding: {

                        //     left : 0,
                        //     right: '4rem'
                        // }
                    },
                    1024: {
                        enabled: false, // Desktopon még mindig ki van kapcsolva
                    },
                }
            },
            checkout: {
                'shipping_price': 0,
                'payment_price': 0,
                'foxpost': null,
                'parcelpoint': null,
                'is_terms': false,
                'is_privacy': false,
                user: {
                    'billing_name': '',
                    'billing_city': '',
                    'billing_postcode': '',
                    'billing_address': '',

                    'shipping_name': '',
                    'shipping_city': '',
                    'shipping_postcode': '',
                    'shipping_address': ''


                }
            },
            shipping:[]
            // checkout: [
            //     shipping_method: null,
            //     shipping_method: null,
            //     comment: ''
            //
            // ]
            // googleMapsInitialized: false

            // products_active: [false, false, false, false, false, false],
            // product_selected: 1
        }
    },

    computed: {
        // prev() {
        //     this.$refs.swiper.$swiper.slidePrev()
        // },
        // next() {
        //     this.$refs.swiper.$swiper.slideNext()
        // },
        // teszt() {
        //
        //     return this.$store.state.products_active[1]
        // },

        //     // console.warn('is_expanded');
        //     // return this.global_products_active[index]
        //     if (index == this.products_active) {
        //         return true
        //     } else {
        //         return false
        //     }
        // }
        // markerSize() {
        //     if (!this.googleMapsInitialized) return null
        //     return new window.google.maps.Size(10, 10)
        // },
        // markerIcon() {
        //     return {
        //         url: 'https://roastopus.com/images/marker.svg',
        //         scaledSize: this.markerSize,
        //     }
        // }
    },
    watch: {
        product_selected: function() {
            // alert('ddd');
        }

    },
    created() {
        console.log('Vue ready... (created)');
        // this.$validator.localize('hu');

        axios.defaults.headers.common['X-CSRF-TOKEN'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
        axios.defaults.headers.common['X-App-Locale'] = language_id;
        this.$i18n.locale = language_id;
        this.loadCart();
        // axios
        // .get('/api/v1/cart', {})
        // .then(response => {
        //     this.cart = response.data
        //
        // });


    },
    mounted() {

        console.log('app.js MOUNTED....');
        //  console.log('$FModal available:', this.$FModal)
    //   this.$nextTick(() => {
    // //   this.swiper.update();
    //   console.log(this.$refs);
    // })
    },
    methods:  {
        //   stripeSubmit () {
        //     // You will be redirected to Stripe's secure checkout page
        //     this.$refs.checkoutRef.redirectToCheckout();
        //   },
        loadCart(refresh = false) {
            // console.log('vue $root loadcart()');
            axios
            .get('/api/v1/cart', {
                params: {
                refresh: refresh
                }
            })
            .then(response => {
                this.cart = response.data;
                // console.log('this.cart:');
                // console.log(this.cart);
                // console.log('response.data.cart.data');
                // console.log(response.data.cart.data);
                // var that = this;
                // this.cartArr = [];
                // _.forEach(response.data.cart.data, function(value, key) {
                //     var obj = {
                //         id: value.id,
                //         price: value.price_plus_vat
                //     };
                //     that.cartArr.push(obj);
                //     // console.log('value', value);
                //     // console.log('key', key);
                //   });


            });
        },
        // teszt() {
        //     console.log('teszt');
        //     this.tesztdata = this.$store.state.products_active
        // },
        validateBeforeSubmit() {
            this.$validator.validateAll().then((result) => {
                if (result) {

                    $('#form1').submit();
                    return;
                }

            })
        },
        outsideClickCartMenuClose() {
            console.log('outsideClickCartMenuClose()');
            this.menu_visible = false;
            // this.$emit('input', this.menu_visible)
        },
        navMenuClose() {

            this.menu_visible = false;

        },
        navclick() {
            this.menu_visible = !this.menu_visible;
        }
    }
});
